(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tyb-field-proof"] && !Shopify.designMode) return;
  try {
    
  function initFieldProofCarousel(section) {
    if (!section || section.dataset.fieldProofReady === 'true') return;

    var track = section.querySelector('[data-field-proof-track]');
    var prev = section.querySelector('[data-field-proof-prev]');
    var next = section.querySelector('[data-field-proof-next]');
    if (!track || !prev || !next) return;

    section.dataset.fieldProofReady = 'true';

    function slideWidth() {
      var card = track.querySelector('.tyb-field-proof__card');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    prev.addEventListener('click', function() {
      track.scrollBy({ left: -slideWidth(), behavior: 'smooth' });
    });

    next.addEventListener('click', function() {
      track.scrollBy({ left: slideWidth(), behavior: 'smooth' });
    });
  }

  document.querySelectorAll('.tyb-field-proof').forEach(initFieldProofCarousel);

  document.addEventListener('shopify:section:load', function(event) {
    var section = event.target.querySelector('.tyb-field-proof');
    if (section) initFieldProofCarousel(section);
  });

  } catch(e) { console.error(e); }
})();
})();
